import React from "react";
import { astryx, useCopyToClipboard, Copy, ReadonlyTextarea } from "@shadowcue/ui";

interface ExportModalProps {
  isOpen: boolean;
  markdown: string | null;
  loading: boolean;
  onClose: () => void;
}

const ExportModal = ({ isOpen, markdown, loading, onClose }: ExportModalProps) => {
  const { copied, copy } = useCopyToClipboard();

  const handleOpenChange = (nextIsOpen: boolean) => {
    if (!nextIsOpen) {
      onClose();
    }
  };

  return (
    <astryx.Dialog isOpen={isOpen} onOpenChange={handleOpenChange} purpose="info" width={640}>
      <astryx.Layout
        header={
          <astryx.DialogHeader
            title="Export"
            subtitle="Copy and paste this into any LLM for further analysis."
            onOpenChange={handleOpenChange}
          />
        }
        content={
          <astryx.LayoutContent>
            {loading ? (
              <astryx.Center padding={8}>
                <astryx.Spinner size="lg" label="Generating report…" />
              </astryx.Center>
            ) : (
              <ReadonlyTextarea value={markdown ?? ""} />
            )}
          </astryx.LayoutContent>
        }
        footer={
          <astryx.LayoutFooter hasDivider>
            <astryx.HStack gap={2} justify="end">
              <astryx.Button label="Close" onClick={onClose} />
              <astryx.Button
                label={copied ? "Copied!" : "Copy all"}
                variant="primary"
                icon={<astryx.Icon icon={Copy} />}
                isDisabled={loading || !markdown}
                onClick={() => markdown && copy(markdown)}
              />
            </astryx.HStack>
          </astryx.LayoutFooter>
        }
      />
    </astryx.Dialog>
  );
};

export default ExportModal;
